import React from 'react';
import Card from '../layout/Card';
import { ChevronDown } from 'lucide-react';

const WidgetUrlSite = ({ icone, sign = "", onClick, active }) => {
    return (
        <Card>
            <button onClick={onClick} className='df aic jcsb w100'>
                <div className='df aic'>
                    <div className='mr3 px1 py1 df aic jcc bcb jc' style={{ borderRadius: "50%" }}  >
                        {icone && (
                            <img style={{ height: "30px", width: "30px", objectFit: "contain" }} src={icone} alt="logo" srcset="" />
                        )}
                        {!icone && sign && <p style={{ height: "30px", width: "30px" }} className='fb df aic jcc cw'>{sign}</p>}
                    </div>
                    <p className='fl tal cw fs12'>Url site</p>
                </div>
                <ChevronDown size={20} color='#fff' style={{ transform: active ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
            </button>
        </Card>
    );
};

export default WidgetUrlSite;
